import * as THREE from 'three';
import type { IPointerHandler } from '@/components/viewPort/PointerController';
import type { SyntheticEvent } from '@/components/viewPort/SyntheticEvent';
import type { IRaycaster } from '../../interfaces';
import type { ImagesService } from './Images.service';
import { ImagesMode } from './interfaces';
import type { SliceType } from './interfaces';
import type { ViewController } from '../../View.controller';

export class PointerHandlerSynchronizeImages implements IPointerHandler {
  private readonly _imagesService: ImagesService;

  private readonly _rayCaster: IRaycaster;

  private readonly _sliceType: SliceType | undefined;

  private readonly _viewController: ViewController;

  private _lastOffsetX: number | undefined;

  private _lastOffsetY: number | undefined;

  public setParent(/*parent: IPointerController*/): void {
    return;
  }

  public constructor(
    imagesService: ImagesService,
    rayCaster: IRaycaster,
    viewController: ViewController,
    sliceType?: SliceType
  ) {
    this._imagesService = imagesService;
    this._rayCaster = rayCaster;
    this._sliceType = sliceType;
    this._viewController = viewController;
  }

  public onFixedClick(event: SyntheticEvent<PointerEvent>): void {
    if (!this._imagesService.isReady()) {
      return;
    }
    if (event.originalEvent.button != 0) {
      return;
    }
    if (this._sliceType !== undefined && this._imagesService.imagesMode === ImagesMode.POLYLINE) {
      return;
    }

    const { offsetX, offsetY } = event.originalEvent;

    if (this._lastOffsetX === offsetX && this._lastOffsetY === offsetY) {
      return;
    }

    const rayCastedPoint3d = this._rayCaster.rayCast(new THREE.Vector2(offsetX, offsetY))?.point;
    if (rayCastedPoint3d) {
      //this._viewController.setActiveCenterLineDescriptor(undefined);
      this._imagesService.syncImages(rayCastedPoint3d);
    }

    this._lastOffsetX = offsetX;
    this._lastOffsetY = offsetY;
  }

  public onPointerCancel(/*event: SyntheticEvent<PointerEvent>*/): void {
    this._lastOffsetX = undefined;
    this._lastOffsetY = undefined;
  }
}
